import _ from 'underscore';
import templateStr from 'text!./enter-payroll.html';
import PayrollReportingUtil from '../../util/PayrollReportingUtil_MSF';

export default [function () {
  return {
    restrict: 'A',
    template: templateStr,

    scope: {},
    controller: ['$filter', '$scope', 'policy.PolicyService', 'PolicyService', 'CancellationService', '$stateParams', '$state', '$timeout', 'ModalService', '$translate', '$rootScope', function ($filter, $scope, PolicyService, GatewayPolicyService, CancellationService, $stateParams, $state, $timeout, ModalService, $translate, $rootScope) {

      $scope.perCapitaInfo = false;
      $scope.payrollDataEmpty = false;
      $scope.clicked = false;
      $scope.percapita = false;
      $scope.item = {};
      $scope.jobNumber = $stateParams.jobNumber;
      $scope.totalClicked = false;
      //Defining Errors
      $scope.partTimeCapita = false;
      $scope.fullTimeCapita = false;
      $scope.closeValidateScreen = false;
      $scope.edit = true;
      $scope.partTimeCapitaEntered = false;
      $scope.fullTimeCapitaEntered = false;

      /**
      * Event to Monitor for closePartTimeCapita and close Part time capita screen
      * @params{String, Object, Object}
      * @returns {void}
      **/
      $scope.$on('closePartTimeCapita', function () {
        $scope.partTimeCapita = false;
        $scope.closeValidateScreen = false;
        $scope.partTimeCapitaEntered = true;
        $scope.perCapitaRecords = [];

        //if payRoll data exists
        if ($scope.auditPayrollResults.payrollData) {
          angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
            if (currentPayroll.partTime) {

              /**
               * checking each record with other records whether we have a match with high rating period
               * if so we don't need to push it
               */
              $scope.partTimeMatch = PayrollReportingUtil.checkPartTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

              /**
               * Push all other items which are not falling into the above case 
               */
              if (!$scope.partTimeMatch) {

                angular.forEach(currentPayroll.partTime, function (partTime, partTimeKey) {

                  $scope.perCapitaRecords.push(partTime);
                });
              }
            }
          }); // End For loop Current Payroll
        }
        $scope.partTimeRecordReady = true;
      }); //End Close Part Time per Capita Event method

      /**
         * Event to Monitor closePartTimeCapitaEmpty. close Part time capita screen	empty data
         * @params{String, Object}
         * @returns{void} - updates partTimeCapita, closeValidateScreen and partTimeCapitaEntered variables on Scope object.
         **/
      $scope.$on('closePartTimeCapitaEmpty', function () {
        $scope.partTimeCapita = false;
        $scope.closeValidateScreen = false;
        $scope.partTimeCapitaEntered = false;
      });
      /**
       * Event to Monitor closeFullTimeCapitalEmpty. close Full time capita screen	empty data
       * @params{String, Object}
       * @returns{void} - updates fullTimeCapita, closeValidateScree and fullTimeCapitaEntered variables on Scope object.
       **/
      $scope.$on('closeFullTimeCapitaEmpty', function () {
        $scope.fullTimeCapita = false;
        $scope.closeValidateScreen = false;
        $scope.fullTimeCapitaEntered = false;
        $state.reload();
      });
      /**
      * Event to Monitor closeFullTimeCapita and show close Full time capita screen
      * @params{String, Object}
      * @returns{void} - updates fullTimeCapita, closeValidateScreen and fullTimeCapitaEntered variables on Scope object.
      **/
      $scope.$on('closeFullTimeCapita', function () {
        $scope.fullTimeCapita = false;
        $scope.closeValidateScreen = false;
        $scope.fullTimeCapitaEntered = true;
        $scope.fullPerCapitaRecords = [];

        if ($scope.auditPayrollResults.payrollData) {
          angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
            if (currentPayroll.fullTime) {
              /**
               * checking each record with other records whether we have a match with high rating period
               * if so we don't need to push it
               */
              $scope.fullTimeMatch = PayrollReportingUtil.checkFullTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

              /**
               * Push all other items which are not falling into the above case 
               */
              if (!$scope.fullTimeMatch) {

                angular.forEach(currentPayroll.fullTime, function (fullTime, fullTimeKey) {

                  $scope.fullPerCapitaRecords.push(fullTime);
                }); //End for loop for currentPayroll
              }
            }
          });
        }
        $scope.fullTimeRecordReady = true;
      }); // End of CloseFullTimeCapita Event

      /**
         * Event to Monitor closePartTimeCapitaEmpty. close Part time capita screen	empty data
         * @params{String, Object}
         * @returns{void} - updates partTimeCapita, closeValidateScreen and partTimeCapitaEntered variables on Scope object.
         **/
      $scope.$on('closePartTimeCapitaEmpty', function () {
        $scope.partTimeCapita = false;
        $scope.closeValidateScreen = false;
        $scope.partTimeCapitaEntered = false;
      });

      /**
      	* Function to Validate PerCapita entered for final payroll report
      	* @params{Object} - payroll
      	* @returns{boolean}
      	**/
      $scope.perCapitaValidation = function (payroll) {
        if ($scope.lastReport && $scope.perCapitaInfo) {
          if (payroll.partTime && payroll.partTime.length == 0) {
            $scope.perCapitaPresent = false;
          }
          if (payroll.partTime != "") {
            angular.forEach(payroll.partTime, function (partTime) {
              if (partTime.totalHours == null) {
                $scope.perCapitaPresent = false;
              }
            });
          }
        }
        return $scope.perCapitaPresent;
      };

      /**
      * Function to Validate fullPerCapita entered for final payroll report
      * @params{Object} - payroll
      * @returns{boolean}
      **/
      $scope.fullPerCapitaValidation = function (payroll) {
        if ($scope.lastReport && $scope.perCapitaInfo) {
          if (payroll.fullTime && payroll.fullTime.length == 0) {
            $scope.fullPerCapitaPresent = false;
          }
          if (payroll.fullTime != "") {
            angular.forEach(payroll.fullTime, function (fullTime) {
              if (!fullTime.name) {
                $scope.fullPerCapitaPresent = false;
              }
            });
          }
        }
        return $scope.fullPerCapitaPresent;
      };

      /**
       * Event to Monitor closeFullTimeCapitalEmpty. close Full time capita screen	empty data
       * @params{String, Object}
       * @returns{void} - updates fullTimeCapita, closeValidateScreen  variables on Scope object.
       **/
      $scope.$on('closeFullTimeCapitaEmpty', function () {
        $scope.fullTimeCapita = false;
        $scope.closeValidateScreen = false;
        $state.reload();
      });

      /**
       * Function to check last report by JobNumber
       * @params{String} - jobNumber
       * @returns{Object} - updates $scope.lastReport variable
       * @private
       **/
      PolicyService.checkLastReport($scope.jobNumber).then(function (data) {
        $scope.lastReport = data;
      });

      $scope.verificationTotal = function (verificationTotalAmount) {

        if (verificationTotalAmount) {
          $scope.auditPayrollResults.verificationTotal.amount = parseFloat(verificationTotalAmount).toFixed(2);
          PolicyService.getCurrency().then(function (resp) {
            $scope.auditPayrollResults.verificationTotal.currency = resp;
          });
        } else {
          var value = document.getElementById('verificationInput').value;
          if (value && value != '') {
            value = value.replace(/[, ]+/g, "").trim();
            value = value.replace('$', '');
            value = parseFloat(value).toFixed(2);
            PolicyService.getCurrency().then(function (resp) {
              $scope.currency = resp;
              if ($scope.currency) {
                $scope.auditPayrollResults.verificationTotal = { amount: value, currency: $scope.currency };
              }
            });
          }
        }
      };

      /**
      * Function to check for any form level errors.
      * @params{void}
      * @returns{boolean} - updates $scope.errorAvailable variable
      * @private
      **/
      $scope.checkFormErrors = function () {
        $scope.errorAvailable = PayrollReportingUtil.checkFormErrors($scope.formErrors);
        return $scope.errorAvailable;
      }; // End of checkFormErrors

      /**
                  * Function to get full time per capita records
                  * @params{Object, Object} - item, payrollData.
                  * @returns{boolean} - updates $scope.fullPerCapitaRecords variable
                  * @private
                  **/
      $scope.getFullPerCapitaRecords = function (item, payrollData) {
        $scope.fullPerCapitaRecords = [];

        if ($scope.auditPayrollResults.payrollData) {
          angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
            if (currentPayroll.fullTime) {

              /**
               * By default considering there are no matching record with high rating period 
               * This will come into place when we have split period
               */

              /**
               * checking each record with other records whether we have a match with high rating period
               * if so we don't need to push it
               */
              $scope.fullTimeMatch = PayrollReportingUtil.checkFullTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

              /**
               * Push all other items which are not falling into the above case 
               */
              if (!$scope.fullTimeMatch) {

                angular.forEach(currentPayroll.fullTime, function (fullTime, fullTimeKey) {

                  $scope.fullPerCapitaRecords.push(fullTime);
                });
              }
            }
          });
        }
        $scope.fullTimeRecordReady = true;

        return $scope.fullPerCapitaRecords;
      }; //End of getFullPerCapitaRecords

      /**
        * Function to get part time percapita records
        * @params{void}
        * @returns{boolean} - updates $scope.errorAvailable variable
        * @private
        **/
      $scope.getPartPerCapitaRecords = function (item, payrollData) {
        $scope.perCapitaRecords = [];

        if ($scope.auditPayrollResults.payrollData) {
          angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
            if (currentPayroll.partTime) {

              /**
               * By default considering there are no matching record with high rating period 
               * This will come into place when we have split period
               */

              /**
               * checking each record with other records whether we have a match with high rating period
               * if so we don't need to push it
               */
              $scope.partTimeMatch = PayrollReportingUtil.checkPartTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

              /**
               * Push all other items which are not falling into the above case 
               */
              if (!$scope.partTimeMatch) {

                angular.forEach(currentPayroll.partTime, function (partTime, partTimeKey) {

                  $scope.perCapitaRecords.push(partTime);
                });
              }
            }
          });
        }
        $scope.partTimeRecordReady = true;
        return $scope.perCapitaRecords;
      }; // End of getPartPerCapitaRecords

      /**
      * Function to get perCapitalClassCodes by JobNumber
      * @params{jobNumber}
      * @returns{Array}
      * @privte
      **/
      PolicyService.getPerCapitaCodesByJobNumber($scope.jobNumber).then(function (perCapitaClassCodesFullData) {
        $scope.perCapitaClasses = PayrollReportingUtil.getClassCodesArray(perCapitaClassCodesFullData);
      });

      /**
                * Function to setup User access
                * @params{String} - policyNumber
                * @returns{Array} - updates $scope.userAccess and $scope.policyViewAccess variable
                * @private
                **/
      $scope.assignPolicyLink = function (policyNumber) {
        PolicyService.userAccess([policyNumber]).then(function (data) {
          $scope.userAccess = data;

          //Assign policy link
          if (policyNumber != null) {
            var _policyNumber = _policyNumber;
            if ($scope.userAccess && $scope.userAccess[_policyNumber] && $scope.userAccess[_policyNumber].length > 0 && ($scope.userAccess[_policyNumber].includes('ACCOUNTMANAGER') || $scope.userAccess[_policyNumber].includes('POLICYHOLDER'))) {
              $scope.policyViewAccess = true;
            } else {
              $scope.policyViewAccess = false;
            }
          }
        }, function (er) {}); //End UserAccess
      };

      /**
                     * Function to get CurrentDate
                     * @params{void}
                     * @returns{boolean} - updates $scope.today variable
                     * @private
                     **/
      $scope.getCurrentDate = function () {
        var currentDate = PolicyService.getCurrentDate();
        currentDate.then(function (res) {
          var splited_currentDate = res.match(/(\d+)/g);
          $scope.today = new Date(splited_currentDate[0], splited_currentDate[1] - 1, splited_currentDate[2], splited_currentDate[3], splited_currentDate[4], splited_currentDate[5]);
        });
      };

      /**
                      * Function to retrieve Full Time per capita records
                      * @params{String, String, String, Object} - jobNumber, EarningsType, classCode, Location
                      * @returns{}
                      **/
      $scope.retrieveFullPerCapita = function (result, jobNumber, payrollData) {
        $scope.perCapitaInfo = true;
        $scope.fullTimePerCapitaPresent = true;
        $scope.eType = result.earningsType;
        PolicyService.getFullTimePerCapita(jobNumber, result.earningsType, result.classCode, result.location, result.personsCovered).then(function (res) {
          result['fullTime'] = res;
          if (res != []) {
            //display percapita records in parent screen
            $scope.getFullPerCapitaRecords(result, payrollData);
            if ($scope.fullPerCapitaRecords) {
              $scope.fullTimeRecordReady = true;
            }
          }
          if (res == undefined || res.length == 0) {
            $scope.fullTimeCapitaEntered = false;
          }
        }); // End of getFullTimePerCapita Record                        
      };

      /**
                      * Function to get Part Time perCapita Records
                      * @params{String, String, String, Object} - jobNumber, earningsType, classCode, Location
                      * @returns{boolean} - udpates $scope.partTimeRecordReady and $scope.partTimePerCapitaEntered value
                      * @private
                      **/
      $scope.retrievePartPerCapita = function (result, jobNumber) {
        $scope.perCapitaInfo = true;
        $scope.partTimePerCapitaPresent = true;
        $scope.eType = result.earningsType;
        PolicyService.getPartTimePerCapita(jobNumber, result.earningsType, result.classCode, result.location, result.personsCovered).then(function (res) {
          result['partTime'] = res;
          if (res != []) {
            //display percapita records in parent screen
            $scope.getPartPerCapitaRecords(result, $scope.auditPayrollResults.payrollData);
            if ($scope.perCapitaRecords) {
              $scope.partTimeRecordReady = true;
            }
          }
          if (res == undefined || res.length == 0 || res[0].totalHours == null) {
            $scope.partTimeCapitaEntered = false;
          }
        }); // End of getPartTimePerCapita
      };

      /**
       * Function to calculate estimated payroll amount for per capita and non percapita class code
       * @param {Object, Integer, Integer} - result, count, restimatedPerCapita_count
       * @returns {void}
       */
      $scope.calculateEstimatedPayrollAmount = function (result, count, estimatedPerCapita_count) {
        if (result.estimatedPayroll.amount) {
          $scope.count = count + result.estimatedPayroll.amount;
        }
        if (result.estimatedPerCapita) {
          $scope.estimatedPerCapita_count = estimatedPerCapita_count + result.estimatedPerCapita;
        }
      };

      /**
       * Function to calculate estimated payroll amount for per capita and non percapita class code
       * @param {Object, Integer, Integer} - result, count, restimatedPerCapita_count
       * @returns {void}
       */
      $scope.assignReportedPayrollAmount = function (result) {
        if (result.reportedPayroll != null && result.reportedPayroll != '') {
          result.reportedPayroll.amount = result.reportedPayroll.amount.toFixed(2);
        }
        if (result.reportedPerCapita != null && result.reportedPerCapita != '') {
          result.reportedPerCapita = result.reportedPerCapita;
        }
      };

      /**
      * Function to get get pay roll data for period by JobNumber and also sets policy view access to true or false.
      * @params{String} - jobNumber
      * @returns{Array}
      * @private
      **/
      var auditPayrollDataPromise = PolicyService.getPayrollDataForPeriod($scope.jobNumber).then(function (res) {
        $scope.auditPayrollResults = res;

        //ACR 18624 - modifiying period end date when entering the payroll
        $scope.auditPayrollResultsBackup = JSON.parse(JSON.stringify($scope.auditPayrollResults));

        angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
          var dateStr = result.ratingExpiredDate;
          var date = new Date(dateStr);
          date.setDate(date.getDate() - 1);
          var newDateStr = date.toISOString();
          result.ratingExpiredDate = newDateStr;
        });

        var dateStr = res.periodEnd;
        var date = new Date(dateStr);
        date.setDate(date.getDate() - 1);
        var newDateStr = date.toISOString();
        $scope.auditPayrollResults.periodEnd = newDateStr;

        //If back button is used the payroll may be complete, do not let them enter again
        if ($scope.auditPayrollResults.isComplete) {
          $scope.hideForm();
        }

        //get current date to update today scope variable
        $scope.getCurrentDate();
        if ($scope.auditPayrollResults.verificationTotal != null && $scope.auditPayrollResults.verificationTotal != '' && $scope.auditPayrollResults.verificationTotal != 0) {
          $scope.auditPayrollResults.verificationTotal.amount = $scope.auditPayrollResults.verificationTotal.amount.toFixed(2);
        }
        if ($scope.auditPayrollResults.payrollData) {
          $scope.partTimeCapitaEntered = true;
          $scope.fullTimeCapitaEntered = true;
          $scope.formErrors = [];
          $scope.count = 0;
          $scope.estimatedPerCapita_count = 0;
          angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
            $scope.retrieveFullPerCapita(result, $stateParams.jobNumber, $scope.auditPayrollResults.payrollData);
            $scope.retrievePartPerCapita(result, $stateParams.jobNumber, $scope.auditPayrollResults.payrollData);
            $scope.calculateEstimatedPayrollAmount(result, $scope.count, $scope.estimatedPerCapita_count);
            $scope.assignReportedPayrollAmount(result);
          }); //End For Loop PayrollData
          $scope.getTotal();
          $scope.getCapitaTotal();
        }
      }, function (error) {});

      $scope.tot_reported_payroll_amount = 0;
      /**
        * Function to get total amounts based on audit payroll reports
        * @params{void}
        * @returns{Object} - updates $scope.tot_reported_payroll_amount
        * @private
        **/
      $scope.getTotal = function () {
        if ($scope.auditPayrollResults) {
          $scope.tot_reported_payroll_amount = null;
          angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
            if (result.reportedPayroll && JSON.stringify(result.reportedPayroll) != '{}' && result.reportedPayroll.amount != '') {
              if ($scope.tot_reported_payroll_amount == null) {
                $scope.tot_reported_payroll_amount = parseFloat(parseFloat(result.reportedPayroll.amount).toFixed(2));
              } else {
                $scope.tot_reported_payroll_amount = parseFloat((parseFloat($scope.tot_reported_payroll_amount) + parseFloat(result.reportedPayroll.amount)).toFixed(2));
              }
            }
          });
        }
      };
      $scope.tot_percapita_amount = 0;
      /**
       * Function to get total PerCapita amounts based on audit payroll reports
       * @params{void}
       * @returns{Object} - updates $scope.tot_percapita_amount
       * @private
       **/
      $scope.getCapitaTotal = function () {
        if ($scope.auditPayrollResults) {
          $scope.tot_percapita_amount = null;
          angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
            if (result.reportedPerCapita !== undefined && result.reportedPerCapita !== '' && result.reportedPerCapita != null || result.reportedPerCapita === 0) {
              if ($scope.tot_percapita_amount == null) {
                $scope.tot_percapita_amount = parseInt(result.reportedPerCapita);
              } else {
                $scope.tot_percapita_amount = $scope.tot_percapita_amount + parseInt(result.reportedPerCapita);
              }
            }
          });
        }
      }; // End of getCapitaTotal
      /**
        * Function to set focus on text element
        * @params{int} - selected index / element
        * @returns{Object} - sets focus on myText HTML element.
        * @private
        **/
      $scope.myFunction = function (index) {
        $scope.enabledEdit = [];
        $scope.enabledEdit[index] = true;
        $scope.clicked = true;
        $timeout(function () {
          angular.element('#myTxt').focus();
        });
      }; //End of myFunction
      /**
         * Function to set focus on selected capita element
         * @params{int} - selected index / element
         * @returns{Object} - sets focus on capita HTML element.
         * @private
         **/
      $scope.reportedPerCapita = function (index) {
        $scope.enabledEditCapita = [];
        $scope.enabledEditCapita[index] = true;
        $timeout(function () {
          angular.element('#capita').focus();
        });
      }; // End of reportedPerCapita
      /**
      * Function to update verification total based on user input in the verificationInput HTML element.
      * @params{String} - status - edit or insert
      * @returns{void} - updates  $scope.auditPayrollResults.verificationTotal values.
      * @private
      **/
      $scope.changeTotalClick = function (status) {
        if (status == 'edit') {
          $scope.totalClicked = true;
          $timeout(function () {
            angular.element('#verificationInput').focus();
          });
        } else {
          var value = angular.element('#verificationInput').val();
          if (parseInt(value) == 0) {
            $scope.auditPayrollResults.verificationTotal.amount = value;
            PolicyService.getCurrency().then(function (resp) {
              $scope.auditPayrollResults.verificationTotal.currency = resp;
            });
          }
          if (value.length == 0) {
            delete $scope.auditPayrollResults.verificationTotal;
          }
          if (value.length > 16) {

            $scope.errMsg = "Can have no more than 16 digits to the left of the decimal point";
          } else {
            $scope.errMsg = false;
            $scope.totalClicked = false;

            if (value && value != '') {
              value = value.replace(/[, ]+/g, "").trim();
              value = value.replace('$', '');
              value = parseFloat(value).toFixed(2);
              $scope.auditPayrollResults.verificationTotal = { amount: value, currency: 'usd' };
            }
            return $scope.errMsg;
          }
        }
      };
      /**
               * Function to update furloughted total based on user input in the furloughedWages HTML element.
               * @params{String} - status - edit or insert
               * @returns{void} - updates  $scope.auditPayrollResults.furloughedWages values.
               * @private
               **/
      $scope.furloughedClick = function (status) {
        if (status == 'edit') {
          $scope.totalClicked = true;
          $timeout(function () {
            angular.element('#furloughedWages').focus();
          });
        } else {
          var value = angular.element('#furloughedWages').val();
          if (parseFloat(value) == 0) {
            $scope.auditPayrollResults.furloughedWages.amount = value;
            PolicyService.getCurrency().then(function (resp) {
              $scope.auditPayrollResults.furloughedWages.currency = resp;
            });
          }
          if (value.length == 0) {
            delete $scope.auditPayrollResults.furloughedWages;
          } else {
            $scope.errMsg = false;
            $scope.totalClicked = false;
            if (value && value != '') {
              value = value.replace(/[, ]+/g, "").trim();
              value = value.replace('$', '');
              value = parseFloat(value).toFixed(2);
              PolicyService.getCurrency().then(function (resp) {
                $scope.auditPayrollResults.furloughedWages = { amount: value, currency: resp };
              });
            }
          }
        }
      };
      /**
               * Function to update and validate verification Total values based on passed amounts
               * @params{Decimal} - verification Total
               * @returns{void} - updates  $scope.auditPayrollResults.verificationTotal & scope.amount values.
               * @private
               **/
      $scope.verification = function (verification_total) {
        if (verification_total) {
          if (verification_total.match(/^\$/) == null) {
            $scope.amount = $filter('currency')(verification_total);
          } else {
            $scope.amount = verification_total;
          }
          $scope.auditPayrollResults.verificationTotal = $scope.amount;
        }
      };
      /**
               * Function to get totals for each item of payroll
               * @params{Object, int} - item, index
               * @returns{void} - updates auditPayrollResult's reported payroll values based on passed in values.
               * @private
               **/
      $scope.estimatedReport = function (item, index) {
        if (item.reportedPayroll && item.reportedPayroll.amount != undefined && item.reportedPayroll.amount.length == 0) {
          delete item.reportedPayroll;
        } else {
          if (item.reportedPayroll && item.reportedPayroll.amount) {
            $scope.auditPayrollResults.payrollData[index].reportedPayroll.amount = parseFloat(item.reportedPayroll.amount).toFixed(2);
            PolicyService.getCurrency().then(function (resp) {
              $scope.auditPayrollResults.payrollData[index].reportedPayroll.currency = resp;
            });
          } else {
            var value = document.getElementById('myTxt' + index).value;
            if (value && value != '') {
              value = value.replace(/[, ]+/g, "").trim();
              value = value.replace('$', '');
              value = parseFloat(value).toFixed(2);

              PolicyService.getCurrency().then(function (resp) {
                $scope.currency = resp;
                if ($scope.currency) {
                  $scope.auditPayrollResults.payrollData[index].reportedPayroll = { amount: value, currency: $scope.currency };
                  $scope.getTotal();
                }
              });
            }
          }
        }
      }; // End of estimatedReport
      /**
        * Function update estimated reported per capita value based on selected Payroll inext
        * @params{Object, int} - item, index
        * @returns{void} - updates auditPayrollResult's reported per capita values based on selected item
        * @private
        **/
      $scope.estimatedreportPerCapita = function (item, index) {
        if (item.reportedPerCapita.length == 0) {
          delete item.reportedPerCapita;
        }
        if (item.reportedPerCapita == 0) {
          $scope.auditPayrollResults.payrollData[index].reportedPerCapita = parseInt(item.reportedPerCapita);
        }
      };
      /**
       * Function restrict user key strokes from UI Screen.
       * @params{event}
       * @returns{boolean}
       * @private
       **/
      $scope.restrictAlphabets = function (event) {
        PayrollReportingUtil.restrictAlphabets(event);
      };

      /**
       * Function to hide/cancel functionality and navigate to payroll details view
       * @params{void}
       * @returns{void}
       * @private
        **/
      $scope.hideForm = function () {
        $state.go('payroll-details', {
          policyNumber: $scope.auditPayrollResults.policyNumber
        });
      };
      /**
      * Function to navigate to policy summary view
      * @params{void}
      * @returns{void}
      * @private
      **/
      $scope.policysummaryForm = function () {
        $state.go('policies.detail.summary', {
          policyNumber: $scope.auditPayrollResults.policyNumber
        });
      };

      /**
                  * Function to check the verification total amount in currency format or not
                  * getCurrency service call is used to get the usd format of the currency
                  * @params {Array} -  auditPayrollResults
                  * @returns {void}
                  */
      $scope.checkVerificationTotAmount = function (auditPayrollResults) {
        if (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount) {
          if (!auditPayrollResults.verificationTotal.currency) {
            PolicyService.getCurrency().then(function (resp) {
              auditPayrollResults.verificationTotal.currency = resp;
            });
            auditPayrollResults.verificationTotal.amount = parseFloat(auditPayrollResults.verificationTotal.amount);
          } else {
            auditPayrollResults.verificationTotal.amount = parseFloat(auditPayrollResults.verificationTotal.amount);
          }
        }
      };

      /**
       * Function to check the reported payroll amount in currency format or not
       * getCurrency service call is used to get the usd format of the currency
       * @params {Array} -  auditPayrollResults
       * @returns {void}
       */
      $scope.checkReportedPayrollAmount = function (auditPayrollResults, result, rkey) {
        if (result.reportedPayroll && result.reportedPayroll.amount) {
          if (!result.reportedPayroll.currency) {
            PolicyService.getCurrency().then(function (resp) {
              auditPayrollResults.payrollData[rkey].reportedPayroll.currency = resp;
            });

            auditPayrollResults.payrollData[rkey].reportedPayroll.amount = parseFloat(result.reportedPayroll.amount);
          } else auditPayrollResults.payrollData[rkey].reportedPayroll.amount = parseFloat(result.reportedPayroll.amount);
        }
      };

      /**
      * Function to save Payroll data
      * @params{Object, Object} - payRollForm, auditPayroll results.
      * @returns{void} -calls service to save payroll information to backend systems.
      * @private
       **/
      $scope.savePayroll = function (PayrollForm, auditPayrollResults) {
        $scope.array_length = auditPayrollResults.payrollData.length;
        angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
          if (auditPayrollResults) {
            $scope.checkVerificationTotAmount(auditPayrollResults);
            $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
            $scope.assignEarningType(result);
          }
        });
        //calling save service
        PolicyService.savePayrollReportData($scope.jobNumber, auditPayrollResults).then(function (data) {
          $scope.hideForm();
        });
      };

      /**
      * Function that toggles between perCapita and Enter and Validate Screen
      * @params{Object, String, String, Object, Object, int} - item,code,type,PayrollForm,auditPayrollResults,fixedId
      * @returns{}
      * @private
       **/
      $scope.showPerCapitaScreen = function (item, code, type, PayrollForm, auditPayrollResults, fixedId) {

        $scope.fullTimePerCapitaValue = false;
        $scope.array_length = auditPayrollResults.payrollData.length;
        angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
          if (auditPayrollResults) {
            var pattern = /[^0-9.-]+/g;
            $scope.checkVerificationTotAmount(auditPayrollResults);
            $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
            if (result.earningsType != 'Employees' && result.personsCovered == item.personsCovered && result.earningsType == item.earningsType && item.classCode == '0908' && result.classCode == '0913' && result.estimatedPerCapita != 0) {
              $scope.fullTimePerCapitaValue = true;
            }
          }
        });
        /**
        * Function that calls save service method SavePayRollDataonClickToReport based on jobNumber and AuditPayrollResults.
        * @params{String, Object} - jobNumber, auditPayRollResults
        * @returns{} - updates partTimeCapitaEntered, fullTimeCapitaEntered, closeValidateScreen on scope object
        * @private
         **/
        $scope.partTimeCapitaEntered = false;
        $scope.fullTimeCapitaEntered = false;
        $scope.perCapitaClassFixedId = fixedId;
        $scope.sharedClass = item;
        if (code == "0908") {
          $scope.partTimeCapita = true;
          $scope.closeValidateScreen = true;
        } else if (code == "0913") {
          $scope.fullTimeCapita = true;
          $scope.closeValidateScreen = true;
        }
        $scope.eType = type;
      };
      /**
                * Function that sets status of clickToReport value to true or false based on ClassCode, personsCovered, earningsType, location and RatingDate and displays show click to report
                * @params{Object} - item
                * @returns{boolean} - sets clickToReport value.
                * @private
                 **/
      $scope.showClickToReport = function (item) {
        var clickToReport = false;
        if (item.classCode == '0908' || item.classCode == '0913' && item.earningsType == 'Employees') {
          clickToReport = true;
          angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
            if (result.personsCovered == item.personsCovered && result.earningsType == item.earningsType && result.location == item.location && item.classCode == result.classCode && item.ratingDate < result.ratingDate) {
              clickToReport = false;
            }
          });
        }
        return clickToReport;
      };

      $scope.initializeScopeVariables = function (auditPayrollResults) {
        $scope.perCapitaError = false;
        $scope.fullPerCapitaError = false;
        $scope.fullPerCapitaPresent = true;
        $scope.perCapitaPresent = true;
        if ($scope.changeTotalClick('display') == true) {
          $scope.totalClicked = true;
          $scope.verification_required = false;
          return false;
        }
        $scope.disableSubmit = true;
        $scope.verification_required = false;
        $scope.reported_payroll = false;
        $scope.verification_invalid = false;
        $scope.reported_per_capita = false;
        $scope.owner_reported_payroll = false;
        $scope.formErrors = [];
        $scope.ownerErrors = [];
        $scope.array_length = auditPayrollResults.payrollData.length;

        auditPayrollResults.firstName = $rootScope.authData.userData.given_name;
        auditPayrollResults.lastName = $rootScope.authData.userData.family_name;
      };

      $scope.checkEarningsType = function (result, perCapita) {
        if (perCapita == 'partTime') {
          if (result.earningsType == 'Employees' || result.earningsType == 'Family Member') {
            partTime.type = 'Employees';
            return partTime.type;
          } else {
            partTime.type = 'Owner Officer';
            return partTime.type;
          }
        }
        if (perCapita == 'fullTime') {
          if (result.earningsType == 'Employees' || result.earningsType == 'Family Member') {
            fullTime.type = 'Employees';
            return fullTime.type;
          } else {
            fullTime.type = 'Owner Officer';
            return fullTime.type;
          }
        }
      };

      /**
                * Function for assigning earning type for part time class code
                * @params{Array} -  partTime result array
                * @returns{void}
                * @private
                 **/
      $scope.assignEarningType = function (result) {
        if (result.partTime) {
          angular.forEach(result.partTime, function (partTime) {
            partTime.id = "0908";
            $scope.perCapita = partTime;
            partTime.type = $scope.checkEarningsType(result, $scope.perCapita);
          });
        }
        if (result.fullTime) {
          angular.forEach(result.fullTime, function (fullTime) {
            fullTime.id = "0913";
            $scope.perCapita = fullTime;
            fullTime.type = $scope.checkEarningsType(result, $scope.perCapita);
          });
        }
      };

      $scope.validateLastPayrollPartTimeClassCode = function (result) {
        if (result.partTime && result.partTime.length >= 0) {
          if ($scope.perCapitaValidation(result) == false) {
            $scope.perCapitaError = true;
            $scope.disableSubmit = false;
          }
        }
      };

      $scope.validateLastPayrollFullTimeClassCode = function (result) {
        if (result.fullTime && result.fullTime.length >= 0) {
          if ($scope.fullPerCapitaValidation(result) == false) {
            $scope.fullPerCapitaError = true;
            $scope.disableSubmit = false;
          }
        }
      };

      $scope.validateOtherPayrollReports = function (result, auditPayrollResults, rkey) {
        if (result.reportedPerCapita) auditPayrollResults.payrollData[rkey].reportedPerCapita = parseInt(result.reportedPerCapita);
        $scope.checkVerificationTotAmount(auditPayrollResults);
        if ($scope.tot_reported_payroll_amount === auditPayrollResults.verificationTotal.amount) {

          $scope.verification_invalid = false;
        } else {
          if (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount > 0) $scope.verification_invalid = true;
          $scope.disableSubmit = false;
          $scope.owner_reported_payroll = false;
        }
      };

      $scope.validateVerificationTotal = function (auditPayrollResults, result) {
        if (!auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal == undefined) {
          $scope.verification_invalid = true;
          $scope.disableSubmit = false;
          $scope.owner_reported_payroll = false;
          $scope.reported_payroll = false;
        }
        if (!auditPayrollResults.verificationTotal && result.reportedPayroll && result.reportedPayroll.amount || auditPayrollResults.verificationTotal && result.reportedPayroll && result.reportedPayroll.amount == "") {
          if ($scope.tot_reported_payroll_amount > 25 || !isNaN($scope.tot_reported_payroll_amount) && $scope.tot_reported_payroll_amount < 0) {
            $scope.verification_invalid = true;
            $scope.disableSubmit = false;
            $scope.owner_reported_payroll = false;
            $scope.reported_payroll = false;
          }
        }
        if (!auditPayrollResults.verificationTotal) {
          $scope.verification_required = true;
          $scope.owner_reported_payroll = false;
          $scope.disableSubmit = false;
        } else {
          $scope.verification_required = false;
        }
      };

      $scope.currencyFormat = function (auditPayrollResults) {
        $scope.checkVerificationTotAmount(auditPayrollResults);
        if ($scope.tot_reported_payroll_amount === auditPayrollResults.verificationTotal.amount) {

          $scope.verification_invalid = false;
          $scope.owner_reported_payroll = false;
        } else {
          if (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount > 0) $scope.verification_invalid = true;
          $scope.disableSubmit = false;
          $scope.owner_reported_payroll = false;
        }
      };

      $scope.formErrorMessage = function (result) {
        var formError = {
          reportedPayroll: { status: false, message: 'Please use Reported Payroll for this Class Code', classCode: result.classCode }
        };
        $scope.formErrors.push(formError);
        $scope.reported_payroll = true;
        $scope.disableSubmit = false;
        $scope.verification_required = false;
      };

      /**
                * Function for validating reported payroll field for payroll data
                * Display error message when verification total difference is more than 25 from reported payroll total                     
                * @params{Object, Object, key} -  auditPayrollResults, result, rkey
                * @returns{void}
                * @private
                 **/
      $scope.validateReportedVal = function (result, auditPayrollResults, rkey) {
        if ($scope.verification_diff_value > 25 || !isNaN($scope.verification_diff_value) && $scope.verification_diff_value < 0) {

          $scope.verification_invalid = true;
          $scope.disableSubmit = false;
          $scope.verification_required = false;
          $scope.reported_payroll = false;
          $scope.owner_reported_payroll = false;
          if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {
            $scope.owner_reported_payroll = false;
            $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
          }
        } else {
          if ($scope.verification_diff_value < 25 || !isNaN($scope.verification_diff_value) && $scope.verification_diff_value < 0) {
            if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {
              $scope.owner_reported_payroll = false;
              $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
              $scope.verification_invalid = false;
              $scope.owner_reported_payroll = false;
              $scope.checkVerificationTotAmount(auditPayrollResults);
            }
          }
          $scope.verification_invalid = false;
          $scope.checkVerificationTotAmount(auditPayrollResults);
          $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
        } //else closed
      };

      /**
                * Function for validating all fields for payroll data
                * Validating verification total field
                * Check whether the payroll is last report or not
                * Validate last payrol report for both part time class code and full time class code
                * Validate payroll othe than last report
                * @params{Object, Object, key} -  auditPayrollResults, result, rkey
                * @returns{void}
                * @private
                 **/
      $scope.validatePayroll = function (auditPayrollResults, result, rkey) {
        $scope.validateVerificationTotal(auditPayrollResults, result);
        if (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount >= 0) {
          $scope.classCode_result = $scope.perCapitaClasses.includes(result.classCode);
          if ($scope.classCode_result) {
            if ($scope.lastReport == true && $scope.showClickToReport(result)) {
              if (result.classCode == '0908') $scope.validateLastPayrollPartTimeClassCode(result);
              if (result.classCode == '0913') $scope.validateLastPayrollFullTimeClassCode(result);

              if (result.reportedPerCapita) auditPayrollResults.payrollData[rkey].reportedPerCapita = parseInt(result.reportedPerCapita);
              $scope.currencyFormat(auditPayrollResults);
            } else {
              $scope.validateOtherPayrollReports(result, auditPayrollResults, rkey);
            }
          } else {
            if ($scope.lastReport == true || $scope.lastReport == false) {
              if (!result.reportedPayroll) {
                $scope.formErrorMessage(result);
                if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {}
              } else {
                $scope.verification_invalid = false;
                var pattern = /[^0-9.-]+/g;
                if ((result.reportedPayroll && result.reportedPayroll.amount == 0 || result.reportedPayroll.amount != 0) && (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount == 0 || auditPayrollResults.verificationTotal.amount != 0)) {
                  $scope.verification_diff_value = Number(Math.abs($scope.tot_reported_payroll_amount - auditPayrollResults.verificationTotal.amount));
                  $scope.validateReportedVal(result, auditPayrollResults, rkey);
                } //if closed
              }
            }
          } //end of validationForReneumerationClassCode()
        }
      };

      /**
                * Function for submitting last payroll data
                * Validating reported payroll has owner officer type
                * Check whether any open policy changes are available or not
                * Handling timeout proxy error based on the status code 502
                * @params{Object} -  auditPayrollResults.
                * @returns{void}
                * @private
                 **/
      $scope.submitPayrollReport = function (auditPayrollResults) {

        var OwnerListPromise = PolicyService.validateOwnerOfficerRepPayroll($scope.jobNumber, auditPayrollResults);
        OwnerListPromise.then(function (data) {
          if (data != '') {
            angular.forEach(data, function (res, ownerkey) {
              $scope.ownerErrors.push(res);
            });
            $scope.disableSubmit = false;
            $scope.owner_reported_payroll = true;
          } else {
            $scope.owner_reported_payroll = false;
            if ($scope.reported_per_capita == false && $scope.verification_invalid == false && $scope.reported_payroll == false && $scope.owner_reported_payroll == false && $scope.fullPerCapitaError == false && $scope.perCapitaError == false) {
              $scope.disableSubmit = true;
              var changePromise = PolicyService.getOpenPolicyChangesForPayroll($scope.jobNumber);
              changePromise.then(function (res) {
                $scope.changePolicyData = res;
                if (res == true) {
                  $scope.invalidPayroll = true;
                  $scope.disableSubmit = false;
                } else {
                  //ACR 18624 - reversing the end date to actual result from PC
                  angular.forEach(auditPayrollResults.payrollData, function (result) {
                    var payRoll = $scope.auditPayrollResultsBackup.payrollData.find(function (a) {
                      return a.fixedId === result.fixedId && a.ratingDate === result.ratingDate;
                    });
                    result.ratingExpiredDate = payRoll.ratingExpiredDate;
                  });

                  auditPayrollResults.periodEnd = $scope.auditPayrollResultsBackup.periodEnd;

                  PolicyService.submitPayrollReportData($scope.jobNumber, auditPayrollResults, false).then(function (data) {
                    PolicyService.createActivityForPortalChanges($scope.auditPayrollResults.policyNumber, auditPayrollResults.periodStart, auditPayrollResults.periodEnd, 'add');
                    GatewayPolicyService.callEUTS('Payroll Report', 'Submit Payroll', $scope.auditPayrollResults.policyNumber, 'Submitted Payroll Report');
                    //redirect to submit screen
                    $state.go('payroll-submit', {
                      jobNumber: $scope.jobNumber
                    });
                  }, function (error) {
                    if (error.baseError && error.baseError.error && typeof error.baseError.error === "string" && error.baseError.error.includes("502")) {
                      $scope.disableSubmit = true;
                      PolicyService.getAuditStatus($scope.jobNumber, auditPayrollResults).then(function (response) {

                        if (response == true) {
                          $state.go('payroll-submit', {
                            jobNumber: $scope.jobNumber
                          });
                        }
                      });
                    }
                    if (error.baseError.error && error.baseError.error.message) {
                      $scope.disableSubmit = false;
                      ModalService.showError('', PayrollReportingUtil.structuredError(error.baseError.error.message));
                    } else {
                      if (error.message) {
                        $scope.disableSubmit = false;
                        ModalService.showError('', PayrollReportingUtil.structuredError(error.message));
                      }
                    }
                  });
                } // end of Else
              }); // End of ChangePromise
            } else {
              $scope.disableSubmit = false;
            }
          }
        }); // End of Owners List Promise
      };

      /**
                     * Function for submitting payroll data
                     * @params{Object, Object} - PayrollForm, auditPayrollResults.
                     * @returns{void}
                     * @private
                      **/
      $scope.submitPayroll = function (PayrollForm, auditPayrollResults) {
        $scope.initializeScopeVariables(auditPayrollResults);
        angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
          //Assigning earning type for percapita class code
          $scope.assignEarningType(result);

          //Validating field level for all payroll before submitting the payroll
          $scope.validatePayroll(auditPayrollResults, result, rkey);
          if (rkey == $scope.array_length - 1) {
            //Complete payroll other than last report by calling submit payroll service
            $scope.submitPayrollReport(auditPayrollResults);
          }
        });
      };
    }]
  };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/EnterPayrollDirective_MSF/EnterPayroll.js
// module id = 1739
// module chunks = 0